import { FC } from 'react';
import { HStack, Text } from '@bpba/ui-components';
import { DEBIN_SUCCESSFUL_MESSAGE } from '../../constants/data';
import styled from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';
import { color, ColorProps } from 'styled-system';
import { StyledBox } from '../shared/StyledBox';

const COMPONENT_COLOR = 'primary.0';

type Props = {
  show: boolean | undefined;
};

export const DebinSuccess: FC<Props> = ({ show }) => {
  if (!show) return <></>;

  return (
    <StyledBox flexDirection="column" alignItems={'center'} py={'48px'}>
      <HStack width="50px">
        <StyledCheckedIcon color={COMPONENT_COLOR} />
      </HStack>
      <Text color={COMPONENT_COLOR} fontWeight={600}>
        {DEBIN_SUCCESSFUL_MESSAGE}
      </Text>
    </StyledBox>
  );
};

const StyledCheckedIcon = styled(FaCheckCircle)<ColorProps>(color, {
  height: '100%',
  width: '100%',
});
